module.exports = __webpack_public_path__ + "img/duck.be5030ca.webp";